import React, { useState } from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import {
  Container, Box, Typography, TextField, Button, Card, CardContent,
  Alert, Link,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';

const AthleteLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = (location.state as any)?.from
    || localStorage.getItem('redirect_after_login')
    || '/athlete/dashboard';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authService.athleteLogin(email, password);
      login(res.data.token, res.data.user);
      localStorage.removeItem('redirect_after_login');
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>
              アスリートログイン
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: '#666' }}>
              キャリアプロフィール管理にログインします
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                label="メールアドレス"
                type="email"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                label="パスワード"
                type="password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mb: 3 }}
              />
              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={loading}
              >
                {loading ? 'ログイン中...' : 'ログイン'}
              </Button>
            </Box>

            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/auth/forgot-password?type=athlete">
                  パスワードを忘れた方
                </Link>
              </Typography>
              <Typography variant="body2">
                アカウントをお持ちでない方は{' '}
                <Link component={RouterLink} to="/auth/athlete-register">新規登録</Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default AthleteLoginPage;
